"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-left: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tlist-style: none;\n\tbackground: url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='5' cy='5' r='5' fill='%233DB0F7'/%3e%3c/svg%3e\")\n\t\tleft center no-repeat;\n\tpadding-left: 2rem;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var LI = _styledComponents.default.li(_templateObject());

LI.displayName = 'LI';

var UL = _styledComponents.default.ul(_templateObject2());

UL.displayName = 'UL';

var BulletedList = function BulletedList(_ref) {
  var items = _ref.items,
      rest = _objectWithoutPropertiesLoose(_ref, ["items"]);

  return _react.default.createElement(UL, rest, items.map(function (item) {
    return _react.default.createElement(LI, {
      key: item
    }, item);
  }));
};

BulletedList.displayName = 'BulletedList';
BulletedList.propTypes = {
  items: (0, _propTypes.arrayOf)(_propTypes.node).isRequired
};
var _default = BulletedList;
exports.default = _default;